import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import { CheckCircle, ArrowLeft, Phone, ChatText } from "@phosphor-icons/react";
import { LogoMark } from "@/components/site/Logo";
import { PHONE, PHONE_HREF, SMS_HREF } from "@/data/content";

export default function ThankYou() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-primary grain flex items-center justify-center px-6" data-testid="thank-you-page">
      <Helmet>
        <title>Thank You | Explus Cleaning LLC</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="relative z-10 w-full max-w-lg text-center"
      >
        <div className="inline-flex items-center gap-2 font-heading text-2xl font-semibold text-white mb-10">
          <LogoMark className="w-8 h-8" gradient />
          Explus <span className="text-emerald-300 -ml-1 font-normal">Cleaning</span>
          <span className="ml-1 text-[0.5em] font-semibold tracking-wider self-start mt-1 text-emerald-300">LLC</span>
        </div>

        <motion.div
          initial={{ scale: 0.7, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.15, type: "spring", stiffness: 200, damping: 14 }}
          className="mx-auto mb-8 w-20 h-20 rounded-full bg-emerald-500/15 flex items-center justify-center"
        >
          <CheckCircle size={56} weight="fill" className="text-emerald-300" />
        </motion.div>

        <h1 className="font-heading text-4xl md:text-5xl font-light tracking-tighter text-white">
          Thank You! Your Quote Request Has Been Received.
        </h1>
        <p className="mt-5 text-lg text-white/80 leading-relaxed">
          We&apos;ll review your request and contact you shortly to discuss your cleaning service.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row justify-center gap-4">
          <a
            href={PHONE_HREF}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white text-primary font-semibold px-8 py-4 min-h-[52px] hover:-translate-y-0.5 hover:shadow-xl transition-all"
            data-testid="thankyou-call-btn"
          >
            <span className="call-ring"><Phone className="call-shake" size={20} weight="fill" /></span> Call {PHONE}
          </a>
          <a
            href={SMS_HREF}
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/70 text-white font-semibold px-8 py-4 min-h-[52px] hover:bg-white/10 transition-colors"
            data-testid="thankyou-text-btn"
          >
            <ChatText size={20} weight="fill" /> Text Us
          </a>
        </div>

        <button
          onClick={() => navigate("/")}
          className="mt-6 inline-flex items-center gap-2 text-white/80 hover:text-white font-medium transition-colors"
          data-testid="back-to-home-btn"
        >
          <ArrowLeft size={18} /> Back to Home
        </button>
      </motion.div>
    </div>
  );
}
